import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import * as countdown from 'countdown';
import { TutorService } from 'src/app/shared/services/tutor/tutor.service';
import { FirebaseAuthComponent } from '../shared/firebase-auth/firebase-auth.component';

@Component({
  selector: 'app-contrato',
  templateUrl: './contrato.component.html'
})
export class ContratoComponent implements OnInit {

  idTutor: any;
  nombresLegales: string;
  apellidosLegales: string;
  tutor: any;
  alumnos: Array<any> = [];

  banderaTerminosCondiciones = false;
  cargando = false;

  nombresValidator = new FormControl('', [
    Validators.required
  ]);
  apellidosValidator = new FormControl('', [
    Validators.required
  ]);

  powerOffIcon = faPowerOff;
  progreso: number;

  constructor(private tutorService: TutorService,
    private firebaseAuth: FirebaseAuthComponent,
    private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.setProgress(25);
    if (this.idTutor != null) {
      localStorage.setItem('idTutor', this.idTutor);
      this.obtenerTutor(this.idTutor);
    }else{
      if (localStorage.getItem('idTutor') != null){
        this.idTutor = localStorage.getItem('idTutor');
        this.obtenerTutor(this.idTutor);
      }else{
        this.tutorService.currentIdTutor$.subscribe(res => {
          this.idTutor = res;
          this.obtenerTutor(this.idTutor);
          localStorage.setItem('idTutor', this.idTutor);
        });
      }
    }
  }

  aceptarTerminosCondiciones(): void {
    if (this.idTutor != null) {
      this.tutorService.crearActualizarTerminosCondiciones(this.idTutor, this.nombresLegales,
        this.apellidosLegales, this.banderaTerminosCondiciones).then(res => {
        }).catch((error) => {
          console.log('error al aceptar  los terminos y condiciones' + error);
        });
    }
  }
  eliminarTerminosCondiciones(): void {
    if (this.idTutor != null) {
      this.tutorService.crearActualizarTerminosCondiciones(this.idTutor, '',
        '', false).then(res => { }).catch((error) => {
          console.log('error al eliminar los terminos y condiciones ' + error);
        });
    }
  }

  actualizarIdTutor(): void {
    setTimeout(() => {
      this.tutorService.changeIdTutor(this.idTutor);
    }, 1000);
  }

  logout(): void {
    this.firebaseAuth.eliminarInscripcionesAlumnos(this.alumnos);
    this.firebaseAuth.logout();
    localStorage.removeItem('idTutor');
  }

  obtenerTutor(id): void {
    this.setProgress(50);
    let tutorObserver = this.tutorService.getUser(id).subscribe(res => {
      this.tutor = res;
      this.nombresLegales = this.tutor?.nombresLegales || '';
      this.apellidosLegales = this.tutor?.apellidosLegales || '';
      this.banderaTerminosCondiciones = this.tutor?.aceptaTerminosCondiciones || false;
      this.establecerDatosAlumnos(this.tutor.alumns);
      this.inicializarContador(this.tutor);
      tutorObserver.unsubscribe();
    });
    this.setProgress(100);
  }

  establecerDatosAlumnos(alumnosTutor): void {
    if (alumnosTutor != null) {
      alumnosTutor.forEach(element => {
        this.cargando = true;
        this.tutorService.getUser(element.id).subscribe(res => {
          this.agregarAlumno(res);
        });
      });
    }
  }
  agregarAlumno(alumno): void {
    let banderaInsertar = true;
    this.alumnos.forEach(element => {
      if (element.id == alumno.id) {
        banderaInsertar = false;
      }
    });
    if (banderaInsertar) {
      if (alumno.status != 'test' && alumno.status != 'matriculado' && alumno.status != 'espera') {
        this.alumnos.push(alumno);
      }
    }
    this.cargando = false;
  }

  inicializarContador(tutorAux): void {
    tutorAux.timeId = countdown(tutorAux.courseSelectedTime, (ts) => {
      tutorAux.time = ts;
      if ((tutorAux.time.minutes === 0) && (tutorAux.time.seconds === 0)){
        console.log('contador llego a cero');
        this.logout();
      }
      this.cambiarSegundoADosDigitos(tutorAux.time.seconds);
      this.cargando = false;
    });
  }

  cambiarSegundoADosDigitos(segundo): void {
    switch (segundo) {
      case 0:
        this.tutor.time.seconds = '00';
        break;
      case 1:
        this.tutor.time.seconds = '01';
        break;
      case 2:
        this.tutor.time.seconds = '02';
        break;
      case 3:
        this.tutor.time.seconds = '03';
        break;
      case 4:
        this.tutor.time.seconds = '04';
        break;
      case 5:
        this.tutor.time.seconds = '05';
        break;
      case 6:
        this.tutor.time.seconds = '06';
        break;
      case 7:
        this.tutor.time.seconds = '07';
        break;
      case 8:
        this.tutor.time.seconds = '08';
        break;
      case 9:
        this.tutor.time.seconds = '09';
        break;
      default:
        break;
    }
  }
  setProgress(percent: number) {
    this.progreso = percent;
    this.cargando = percent < 100;
    this.cd.markForCheck();
    this.cd.detectChanges();
  }
}
